import React from 'react'
import { Title, message } from 'components/misc'
import UpgradeLink from '../UpgradeLink'
import { useFeatures } from 'core/hooks'

const UPGRADE_LINK_PATTERN = '\\[(.*?)]'
const HIGHLIGHT_TEXT_PATTERN = '%(.*?)%'

const SystemMessage = ({ type, title, text, children, upgradeLink, highlightText }) => {
    const { isCreditSite } = useFeatures()

    if (isCreditSite && text == 'userWarning') {
        text = 'userWarningCredits'
        upgradeLink = (linkText, key) => <UpgradeLink href={CONFIG.urls.terms} key={key}>{linkText}</UpgradeLink>
    }

    return (
    <div className={`message-wrapper system-message system-message--${type}`}>
        <p className={`system-message__header system-message__header--${type}`}><Title>{title}</Title></p>
        <div className="system-message__body">
        {children || <p>{replaceTextWithComponent(message(text), { upgradeLink, highlightText })}</p>}
        </div>
    </div>
)}

SystemMessage.defaultProps = {
  title: 'upgrade',
  text: 'upgrade',
  type: 'error',
  upgradeLink: (linkText, key) => <UpgradeLink key={key}>{linkText}</UpgradeLink>,
  highlightText: (text, key) => <span key={key} className="attention-text">{text}</span>,
}

const replaceTextWithComponent = (text = '', { upgradeLink, highlightText }, pattern = new RegExp(`(${UPGRADE_LINK_PATTERN})|(${HIGHLIGHT_TEXT_PATTERN})`, 'g')) => {
  const upgradeLinkRegex = new RegExp(UPGRADE_LINK_PATTERN)
  const hightlightTextRegex = new RegExp(HIGHLIGHT_TEXT_PATTERN)
  const matches = text.split(pattern)
  let result = []
  while (matches.length > 0) {
    let m = matches.shift()

    const shiftNext = () => {
      if (matches.length > 1) {
        m = matches.shift()
      }
    }

    if (!m || m.length === 0) {
      continue
    }

    if (m.match(pattern)) {
      if (m.match(upgradeLinkRegex)) {
        shiftNext()
        result.push(upgradeLink(m, matches.length))
      }
      if (m.match(hightlightTextRegex)) {
        shiftNext()
        result.push(highlightText(m, matches.length))
      }
    } else {
      result.push(m)
    }
  }
  return result
}

export default SystemMessage
